import React, {useEffect, useState} from 'react';
import OnboardInput from "../../component/base/onboard-input/OnboardInput";
import OnboardPassword from "../../component/base/onboard-password/OnboardPassword";
import OnboardButton from "../../component/base/onboard-button-component/OnboardButton";
import OnboardDialog from "../../component/base/onboard-dialog-component/OnboardDialog";
import NotNullCheck from "../../util/NotNullCheck";
import {isEmpty, rnd} from "../../util/Validation";
import OnboardPrice from "../../component/base/onboard-price-component/OnboardPrice";
import {changePrice, getMilesOrMil} from "../../util/Currency";
import CompletedComponent from "../../component/base/completed-component/CompletedComponent";
import OnboardCheckboxAgreement
    from "../../component/base/onboard-checkbox-agreement-component/OnboardCheckboxAgreement";
import LoginStateManager from "../../util/LoginStateManager";
import VerifyTypeEnum from "../../enum/VerifyTypeEnum";
import OnboardMilesSmilesCard from "../../component/base/onboard-miles-smiles-card-component/OnboardMilesSmilesCard";
import parse from "html-react-parser";
import {getDistanceSalesDescriptionDomesticORInternational} from "../../util/LanguageContentManager";
import {setSimulationNumber} from '../../util/SimulationManager';

const PaymentWithMil = (props) => {
    const {t, i18n, navigate, user, flight, setLoading} = props.props;
    const simulationNumber = setSimulationNumber();
    const {payment} = props;

    const [memberId, setMemberId] = useState(user?.memberId !== undefined ? user?.memberId : null);
    const [passcode, setPasscode] = useState(null);
    const [distanceSalesContract, setDistanceSalesContract] = useState(false);
    const {setUserAddQuotas} = new LoginStateManager(props.props, user?.verifyType);

    const [error, setError] = useState(null);
    const [dialog, setDialog] = useState({
        visible: false,
        title: "",
        content: "",
        isError: false,
        confirmShow: true,
        cancelText: t('cancel')
    });
    const [completed, setCompleted] = useState({
        visible: false,
        error: false,
        title: "",
        description: "",
        confirmText: "",
        remainingMiles: null
    });

    const handleCompleted = () => {
        setLoading(true);
        setDialog({...dialog, visible: false});
        if (isUserVerifyTypeMilesAndSmiles()) buyPackageNotToken();
        else handleLoginWithMilesAndSmiles();
        // else if (user?.verifyType === VerifyTypeEnum.SEAT_OR_TICKET) {
        //     if (user?.memberId === null)
        //     handleLoginWithMilesAndSmiles();
        //     else
        //         buyPackageNotToken();
        // } else if (user?.verifyType === VerifyTypeEnum.FORGOT_PASSCODE) buyPackageNotToken();
    }

    const handleLoginWithMilesAndSmiles = () => {
        buyPackage();
        // verifyMsMemberWithPin(memberId.replace(" | ", ""), passcode, false, 1).then(response => {
        //     if (response.data?.responseHeader?.statusCode === 'FAILURE') {
        //         handleMessageError(t("payment.error.content"));
        //     } else {
        //         buyPackage();
        //     }
        // }).catch((e) => {
        //     handleMessageError(t("payment.error.content"));
        // });
    }

    const buyPackage = () => {
        let member = memberId.replace(" | ", "");
        if (member === "TK123456789" && passcode === null) {
            handleMessageSuccess(2250);
        } else if (member === "TK123456789" && passcode === "123456") {
            handleMessageSuccess(2250);
        } else handleMessageError(t("payment.error.content"));
        // handleMessageError(t("payment.error.content"));
    }

    const buyPackageNotToken = () => {
        handleMessageSuccess(2250);
    }

    const handleMessageSuccess = (currentMiles) => {
        simulationNumber(5, 4);
        setLoading(false);
        setCompleted({
            visible: true,
            error: false,
            title: t("payment.success.title"),
            description: t("payment.success.content"),
            confirmText: t("payment.success.confirm"),
            remainingMiles: currentMiles
        });
    }

    const handleMessageError = (desc) => {
        setLoading(false);
        setCompleted({
            visible: true,
            error: true,
            title: t("payment.error.title"),
            description: desc,
            confirmText: t("payment.error.confirm")
        });
    }

    const validation = () => {
        let valid = {
            memberId: (memberId == null || memberId.length === 0) ? t('error.empty_member_id') : null,
            passcode: (passcode == null || passcode.length === 0) ? rnd(t('error.empty_password')) : null,
            distanceSalesContract: (distanceSalesContract == null || !distanceSalesContract) ? rnd(t('error.empty_approve')) : null,
        };
        setError(valid);
        if (user?.passcode) valid.passcode = null;
        if (user?.memberId !== null) valid.passcode = null;
        if (NotNullCheck(valid)) {
            if (priceCheck()) {
                setDialog({
                    visible: true,
                    title: t("payment.not_enough_miles.title"),
                    content: t("payment.not_enough_miles.content"), isError: true, confirmShow: false,
                    cancelText: t('okay')
                })
            } else {
                setDialog({
                    visible: true,
                    title: t("payment.alert.title").replace('{price}', changePrice(payment?.payMIL) + " " + getMilesOrMil(i18n, payment?.payMIL)),
                    content: t("payment.alert.content"), isError: false, confirmShow: true,
                    cancelText: t('cancel')
                })
            }
        }
    }

    useEffect(() => {
        if (error !== null) {
            let valid = {
                memberId: (memberId == null || memberId.length === 0) ? t('error.empty_member_id') : null,
                passcode: (passcode == null || passcode.length === 0) ? rnd(t('error.empty_password')) : null,
                distanceSalesContract: (distanceSalesContract == null || !distanceSalesContract) ? rnd(t('error.empty_approve')) : null,
            };
            setError(valid);
        }
    }, [i18n.language])

    const isUserVerifyTypeMilesAndSmiles = () => {
        return user?.verifyType === VerifyTypeEnum.MILES_A_SMILES;
    }

    const priceCheck = () => {
        if (user.totalMiles === null || user.totalMiles === undefined) return false;
        return parseFloat(payment?.payMIL) > parseFloat(user.totalMiles)
    }

    const getDistanceSalesDescription = () => {
        let isTrLang = /tr/.test(i18n.language.toLowerCase());
        return parse(t('contracts.payment_credit_card_distance_sales_pia').toString()
            .replace("{passport}", user.passportNumber ? user.passportNumber : '')
            .replace("{tckn}", user.tcIdentity ? user.tcIdentity : '')
            .replace("{date}", new Date().toLocaleDateString())
            .replace("{email}", user.email ? user.email : '')
            .replace("{packagePrice}", payment?.price + (flight.domestic ? ' TL' : " USD") + " / " + payment.payMIL + " " + getMilesOrMil(i18n, payment.payMIL))
            .replace("{packageName}", payment.title)
            .replace("{packageDesc}", payment.title)
            .replace("{packageType}", getDistanceSalesDescriptionDomesticORInternational(flight.domestic, i18n))
        )
    }

    const distanceSalesContractCheckbox = {
        label: t('payment.distance_sales_contract'),
        link: [{
            text: t('payment.distance_sales_contract_link'),
            agreement: {
                confirm: true,
                title: t('payment.distance_sales_contract_header'),
                description: getDistanceSalesDescription()
            }
        }]
    }

    return (
        <div>

            {user.memberId !== null && (
                <OnboardMilesSmilesCard
                    fullname={(user.name === undefined ? '' : user.name) + " " + (user.surname === undefined ? '' : user.surname)}
                    memberId={user.memberId}
                    mil={changePrice(user.totalMiles)}
                    cardType={user.package}
                />
            )}

            <OnboardPrice price={payment?.payMIL} currency={getMilesOrMil(i18n, payment?.payMIL)} isMil
                          mil={user.totalMiles}/>

            {user.memberId === null && (
                <OnboardInput placeholder={t('login.input_ms_member_id')} onChange={(e) => setMemberId(e)}
                              error={error?.memberId}
                              mask={{mask: "TK \\| 9{1,9}", definitions: {"*": {casing: "upper"}}}}
                              validation={isEmpty(memberId, t('error.empty_member_id'))}
                              value={memberId}/>
            )}

            {(user.passcode === null && user.memberId === null) && (<div className="h-8"/>)}
            {(user.passcode === null && user.memberId === null) && (
                <OnboardPassword placeholder={t('login.password')} onChange={(e) => setPasscode(e)}
                                 error={error?.passcode}
                                 validation={isEmpty(passcode, t('error.empty_password'))}
                                 onClickPasswordForgot={() => navigate("/forgot-password", {state: "payment"})}
                                 value={passcode}/>
            )}

            <div className="h-24"/>

            <OnboardCheckboxAgreement
                value={distanceSalesContract}
                error={error?.distanceSalesContract}
                onChange={(e) => setDistanceSalesContract(e)}
                label={distanceSalesContractCheckbox}/>

            <div className="h-20"/>

            <OnboardButton label={user?.memberId ?
                t('buy') : t('payment.login_and_payment')} onClick={() => validation()}/>

            <OnboardDialog moneyIcon={!dialog.isError} error={dialog.isError}
                           visible={dialog.visible}
                           title={dialog.title}
                           content={dialog.content}
                           confirmText={t('payment.alert.confirm')} confirmShow={dialog.confirmShow}
                           onClickConfirm={() => handleCompleted()}
                           cancelShow cancelText={dialog.cancelText}
                           onClickCancel={() => setDialog({...dialog, visible: false})}
            />

            <CompletedComponent
                visible={completed.visible}
                error={completed.error}
                title={completed.title}
                description={completed.description}
                confirmText={completed.confirmText} hiddenCopy
                remainingMiles={completed.remainingMiles}
                confirm={() => {
                    if (completed.error) setCompleted({...completed, visible: false});
                    else navigate("/remaining-usage")
                }}/>

        </div>

    );
};

export default PaymentWithMil;

